import { render, staticRenderFns } from "./ImportFeedback.vue?vue&type=template&id=0e7b6dfe&"
import script from "./ImportFeedback.vue?vue&type=script&lang=js&"
export * from "./ImportFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports